import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dg-wheel__text-wrapper" }
const _hoisted_2 = { class: "dg-wheel__text" }
const _hoisted_3 = { class: "dg-wheel__options" }

import { ref, onMounted, onBeforeUnmount, computed } from 'vue'

import type { QuestionnaireView } from '@/models/onboarding'
import type { DailyGoalChoice } from '@/models/onboarding.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'DailyGoalWheel',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const selectedItem = computed(() => {
  return props.view.currentChoice as DailyGoalChoice
})

// This is a Set instead of an array because Set ensures all items are unique.
const visibleItems = ref<Set<number>>(new Set())

const containerRef = ref<HTMLElement | null>(null)
const optionRefs = ref<HTMLElement[]>([])

const observer = ref<IntersectionObserver | null>(null)

onMounted(() => {
  // This observer adds items to `visibleItems` when they appear in the scroll wheel
  // and removes them when they disappear, so `visibleItems` always has the items
  // currently visible in the wheel.
  // After updating `visibleItems`, it assigns the value of the item in the middle
  // to `selectedItem`.
  observer.value = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const number = parseInt(entry.target.innerHTML)

        if (entry.isIntersecting) {
          visibleItems.value.add(number)
        } else {
          visibleItems.value.delete(number)
        }

        updateSelectedItem()
      })
    },
    { threshold: 0.5, root: containerRef.value },
  )

  optionRefs.value.forEach((el) => {
    observer.value?.observe(el)
  })

  // Scroll to the default value.
  optionRefs.value[selectedItem.value - 1]?.scrollIntoView()
})

onBeforeUnmount(() => {
  observer.value?.disconnect()
})

/**
 * Update `view.currentChoice` with the selected item (the item in the middle of the wheel).
 */
function updateSelectedItem(): void {
  const visibleItemsArray = Array.from(visibleItems.value)
  const sum = visibleItemsArray.reduce((sum, num) => sum + num, 0)

  // The item in the middle is the average of all other items.
  // The value is rounded up because at the top of the wheel
  // there are some negative values that break this logic.
  // For example: `[-1, -2, -3, 1, 2, 3, 4]`. The item in the
  // middle is `1`, but the average of the sum of this array is
  // `0.57`. If we round it up, we get `1`.
  props.view.setCurrentChoice(Math.ceil(sum / visibleItemsArray.length))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "dg-wheel"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(_toDisplayString(selectedItem.value * 2) + " guides ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        _cache[1] || (_cache[1] = _createTextVNode("/ month", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
        return _createElementVNode("div", {
          key: -n,
          ref_for: true,
          ref_key: "optionRefs",
          ref: optionRefs,
          class: "dg-wheel__option dg-wheel__option--placeholder"
        }, _toDisplayString(-n), 1)
      }), 64)),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(99, (n) => {
        return _createElementVNode("div", {
          key: n,
          ref_for: true,
          ref_key: "optionRefs",
          ref: optionRefs,
          class: _normalizeClass(["dg-wheel__option", {
          'dg-wheel__option--current': selectedItem.value === n,
        }])
        }, _toDisplayString(n), 3)
      }), 64)),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
        return _createElementVNode("div", {
          key: 99 + n,
          ref_for: true,
          ref_key: "optionRefs",
          ref: optionRefs,
          class: "dg-wheel__option dg-wheel__option--placeholder"
        }, _toDisplayString(99 + n), 1)
      }), 64))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "dg-wheel__label" }, "min", -1))
  ], 512))
}
}

})